import React, { useState ,useEffect} from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import Select from "react-select";

import moment from "moment";
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isDriver, setBranch] = useState(props ? props.driverRec : {});
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      
      const fnYear = await trasportApi.fetchAllCountry();
  
      if (fnYear && fnYear.length) {
        let ar = [];
        //eslint-disable-next-line
        fnYear.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.name;
          ar.push(obj);
        });
        if (props?.driverRec) {
          let acc = ar.filter((acc) => acc.value === props.driverRec.country_id);
          setSelectedFinancialYear(acc);
        }

        
        // // Check if the current year matches any option
        // const currentYear = new Date().getFullYear();
        // const defaultOption = ar.find(option => option.label === currentYear.toString());

        // if (defaultOption) {
        // setSelectedFinancialYear([defaultOption]); // Set the default selected option
        // }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };
  
    fetchData();
  }, []);
 
  const checkRequiredFields = () => {
    if (
      isDriver.country_id &&
      isDriver.country_id.trim() !== "" &&
      isDriver.state_name &&
      isDriver.state_name.trim() !== ""
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};

    if (isDriver.id) {
      result2 = await trasportApi.saveState(isDriver);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createState(isDriver);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setBranch({ ...isDriver, country_id: e.value });
  };

  const handleDriver  = async (e) => {
    setBranch({ ...isDriver, [e.target.name]: e.target.value });
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Driver
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Country
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Country.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        State Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="state_name"
                        placeholder="Enter State Name"
                        value={isDriver.state_name}
                        onChange={handleDriver}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
